import React from 'react'
import { eachDay } from 'date-fns'

import { isWebmSupported, isMobileDevice } from '../../../utils/AppUtils'
import uiStore from '../../../utils/UIStore'

import BookingResponseMessage from '../BookingResponseMessage'

import { MobileContainer, DesktopContainer } from './styledComponents'
import LandingDesktop from './index.desktop'
import LandingMobile from './index.mobile'

class LandingPage extends React.Component<Props> {
  constructor(props) {
    super(props)
    this.state = {
      formData: null // eslint-disable-line
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.isPageResized, false)
  }

  isPageResized = () => {
    if (window.innerWidth > window.innerHeight && !isMobileDevice()) {
      this.closeMobileForm()
      this.bookingResponseModalRef.closeModal()
    }
  }

  setFormDataState = formData => {
    this.setState({
      formData // eslint-disable-line
    })
  }

  onFormSubmitSuccess = formData => {
    this.setFormDataState(formData)
    // open booking response modal
    this.openBookingResponseModal()
  }

  openBookingResponseModal = () => {
    if (this.bookingResponseModalRef) {
      this.bookingResponseModalRef.openModal()
    }
  }

  captureBookingResponseModalRef = ref => {
    if (ref) {
      this.bookingResponseModalRef = ref
    }
  }

  captureFormDesktopRef = ref => {
    if (ref) {
      this.formDesktopRef = ref
    }
  }

  captureFormMobileRef = ref => {
    if (ref) {
      this.formMobileRef = ref
      uiStore.captureFormMobileRef(ref)
    }
  }

  closeLightBoxCallBack = () => {
    if (this.formDesktopRef) {
      this.formDesktopRef.resetForm()
    }
    if (this.formMobileRef) {
      this.formMobileRef.resetForm()
    }
  }

  closeMobileForm = () => {
    if (this.formMobileRef) {
      this.formMobileRef.closeModal()
    }
  }

  onClickBookMySlot = () => {
    if (this.formMobileRef) {
      this.formMobileRef.openModal()
    }
  }

  getVideoUrl = () => {
    const { landingPageDetails } = this.props
    const landingPageDetailsObject = landingPageDetails
    if (isWebmSupported()) {
      return {
        mobile: landingPageDetailsObject.tabletbgvideowebm,
        desktop: landingPageDetailsObject.desktopbgvideowebm,
        tablet: landingPageDetailsObject.mobilebgvideowebm,
        type: 'video/webm'
      }
    }
    return {
      mobile: landingPageDetailsObject.tabletbgvideomp4,
      desktop: landingPageDetailsObject.desktopbgvideomp4,
      tablet: landingPageDetailsObject.mobilebgvideomp4,
      type: 'video/mp4'
    }
  }

  getConvertedDate = date => (date ? new Date(date) : null)

  render() {
    const {
      mobile: mobileVideoUrl,
      desktop: desktopVideoUrl,
      type: videoType
    } = this.getVideoUrl()
    const {
      amanoraSectionDetails,
      landingPageDetails,
      priceCardsData,
      termsAndConditionsData,
      bookingResponseData,
      pagePrefix,
      isOnePlusOneOfferPresentInPriceCards
    } = this.props

    const { formData } = this.state
    const {
      bookingIDPrefix,
      arcadeFormMauticID,
      arcadeCity,
      arcadeClosingDate,
      arcadeClosingEndDate,
      arcadeClosedDatesList
    } = bookingResponseData
    let excludeDates = arcadeClosedDatesList
      ? eachDay(
          this.getConvertedDate(arcadeClosingDate),
          this.getConvertedDate(arcadeClosingEndDate)
        ).concat(
          arcadeClosedDatesList
            .split(',')
            .map(date => this.getConvertedDate(date))
        )
      : eachDay(
          this.getConvertedDate(arcadeClosingDate),
          this.getConvertedDate(arcadeClosingEndDate)
        )
    return (
      <div id={`arcade-landing-section`}>
        <MobileContainer>
          <LandingMobile
            ref={this.captureLandingMobileRef}
            videoType={videoType}
            videoUrl={mobileVideoUrl}
            onFormSubmitSuccess={this.onFormSubmitSuccess}
            captureFormMobileRef={this.captureFormMobileRef}
            landingPageDetails={landingPageDetails}
            termsAndConditionsData={termsAndConditionsData}
            slotIdPrefix={bookingIDPrefix}
            arcadeFormMauticID={arcadeFormMauticID}
            arcadeCity={arcadeCity}
            pagePrefix={pagePrefix}
            priceCardsData={priceCardsData}
            excludeDates={excludeDates}
            amanoraSectionDetails={amanoraSectionDetails}
            bookingResponseData={bookingResponseData}
            bookingInfo={formData}
            isOnePlusOneOfferPresentInPriceCards={
              isOnePlusOneOfferPresentInPriceCards
            }
          />
        </MobileContainer>
        <DesktopContainer className="cd-hero-container">
          <LandingDesktop
            videoType={videoType}
            pagePrefix={pagePrefix}
            videoUrl={desktopVideoUrl}
            onClickBookMySlot={this.onClickBookMySlot}
            onFormSubmitSuccess={this.onFormSubmitSuccess}
            captureFormDesktopRef={this.captureFormDesktopRef}
            captureFormMobileRef={this.captureFormMobileRef}
            landingPageDetails={landingPageDetails}
            termsAndConditionsData={termsAndConditionsData}
            slotIdPrefix={bookingIDPrefix}
            arcadeFormMauticID={arcadeFormMauticID}
            arcadeCity={arcadeCity}
            priceCardsData={priceCardsData}
            excludeDates={excludeDates}
            isOnePlusOneOfferPresentInPriceCards={
              isOnePlusOneOfferPresentInPriceCards
            }
          />
        </DesktopContainer>
        <BookingResponseMessage
          amanoraSectionDetails={amanoraSectionDetails}
          bookingResponseData={bookingResponseData}
          bookingInfo={formData}
          ref={this.captureBookingResponseModalRef}
          closeLightBoxCallBack={this.closeLightBoxCallBack}
          closeMobileForm={this.closeMobileForm}
          pagePrefix={pagePrefix}
        />
      </div>
    )
  }
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/components/IbcArcade/LandingPage/index.js